var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.919,
    cy: 12,
    r: 12,
    fill: "#466EC4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.635 20c-.13 0-.39 0-.52-.124a.577.577 0 010-.864l5.983-5.684c.78-.741.78-1.853 0-2.594L16.115 5.05a.577.577 0 010-.865.652.652 0 01.91 0L23.01 9.87c.65.617.91 1.359.91 2.224 0 .864-.39 1.606-.91 2.224L17.025 20h-.39z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightBlue);
export default __webpack_public_path__ + "static/media/chevron-right-blue.73d2365efdd0537c47a8a6c403a99762.svg";
export { ForwardRef as ReactComponent };